import { registerPlugin } from '@capacitor/core';

export interface LumioIAPPlugin {
  getMonthlyPrice(options: { productId: string }): Promise<{ price: string | null }>;
  /** Returns transactionId WITHOUT finishing the StoreKit transaction.
   *  Caller must call finishTransaction after /billing/apple/verify succeeds. */
  purchaseMonthly(options: { productId: string; appAccountToken: string }): Promise<{ transactionId: string }>;
  /** Marks a StoreKit transaction as finished. Call only after /verify succeeds. */
  finishTransaction(options: { transactionId: string }): Promise<void>;
  /** Returns IDs of verified but unfinished StoreKit transactions (for launch drain). */
  getPendingTransactions(): Promise<{ transactionIds: string[] }>;
  /** Calls AppStore.sync() to refresh entitlements before /billing/apple/restore. */
  restorePurchases(): Promise<void>;
}

export const LumioIAP = registerPlugin<LumioIAPPlugin>('LumioIAP');
